exports.f = require('./_wks');



// WEBPACK FOOTER //
// webpack:///node_modules/core-js/library/modules/_wks-ext.js